<template>
    <div class="flex items-center gap-2">
        <svg
            class="h-9 w-9 shrink-0 fill-current"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
        >
            <!-- Document / invoice shape with lines -->
            <path
                d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm0 2v5h5l-5-5zm-4 4h8v1.5h-8V8zm0 3h8v1.5h-8V11zm0 3h5v1.5h-5V14z"
            />
        </svg>
        <span class="text-xl font-semibold tracking-tight">Invoicius</span>
    </div>
</template>
